import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EmployeeList from './pages/EmployeeList';
import EmployeeDetail from './pages/EmployeeDetail';
import TeamAnalysis from './pages/TeamAnalysis';
import Compatibility from './pages/Compatibility';
import Reports from './pages/Reports';
import ManagerTools from './pages/ManagerTools';
import Settings from './pages/Settings';

export default function App() {
  const { user, loading, error, login, register, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-14 h-14 rounded-xl bg-primary flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
            適
          </div>
          <div className="text-sm text-text-muted">読み込み中...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={login} onRegister={register} error={error} loading={loading} />;
  }

  return (
    <Routes>
      <Route element={<Layout user={user} onLogout={logout} />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/employees" element={<EmployeeList />} />
        <Route path="/employees/:id" element={<EmployeeDetail />} />
        <Route path="/team" element={<TeamAnalysis />} />
        <Route path="/compatibility" element={<Compatibility />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/manager-tools" element={<ManagerTools />} />
        <Route path="/settings" element={<Settings user={user} />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
